import BlockAttachments from "components/Dashboard/DoctorDashboard/notes-and-forms/components/block-attachments/BlockAttachments";
import { useBlockAttachments } from "components/Dashboard/DoctorDashboard/notes-and-forms/scenes/note-fill-in/contexts/BlockAttachmentsContext";
import RichTextEditor from "components/rich-text-editor/RichTextEditor";
import DOMPurify from "dompurify";
import isEmptyHtmlContent from "notes-and-forms-v2/util/isEmptyHtmlContent";
import getClasses from "utils/getClasses";
import {
  ElementViewForClipboardProps,
  ElementViewProps,
} from "../AtomicElementView";
import styles from "./ParagraphContent.module.scss";

function parseRawData(data) {
  if (!data) {
    return "";
  }

  return DOMPurify.sanitize(data.toString());
}

export function ParagraphContentForClipboard({
  data: rawData,
}: ElementViewForClipboardProps<ParagraphElement>) {
  const sanitizedData = parseRawData(rawData);

  return (
    <div dangerouslySetInnerHTML={{ __html: sanitizedData || "No answer" }} />
  );
}

export default function ParagraphContent({
  data: rawData,
  element,
  onChange,
  isPrintMode,
  isLocked,
  disabled,
  showAsMissing,
}: ElementViewProps<ParagraphElement>) {
  const sanitizedData = parseRawData(rawData);

  const { onUpload } = useBlockAttachments();

  const isEmpty = isEmptyHtmlContent(sanitizedData);

  if (isPrintMode) {
    if (isEmpty) {
      return (
        <div>
          <div className={styles.htmlContent}>No answer</div>
          <BlockAttachments id={element.id} mode="print" />
        </div>
      );
    }

    return (
      <div>
        <div
          className={styles.htmlContent}
          dangerouslySetInnerHTML={{ __html: sanitizedData }}
        />
        <BlockAttachments id={element.id} mode="print" />
      </div>
    );
  }

  return (
    <div>
      <RichTextEditor
        className={getClasses(showAsMissing && isEmpty && styles.missing)}
        editorClassName={getClasses(
          styles.editorContent,
          isLocked && styles.locked,
        )}
        value={sanitizedData}
        placeholder={isLocked ? "No answer" : "Enter Paragraph Answer"}
        onChange={onChange}
        disabled={disabled || isLocked}
        hideToolbar={isLocked}
        onUpload={onUpload ? (event) => onUpload(event, element.id) : undefined}
      />
      <div className={styles.attachments}>
        <BlockAttachments id={element.id} mode="fill" />
      </div>
    </div>
  );
}
